import { Outlet } from 'react-router-dom';
import { AssistantPanel } from '@/components/assistant/AssistantPanel';
import { AssistantProviders } from '@/components/assistant/AssistantShell';
import { CalendarReauthorizationBanner } from '@/components/practitioner/CalendarReauthorizationBanner';
import { ElevatedWorkspaceBanner } from '@/components/practitioner/ElevatedWorkspaceBanner';
import { useAuth } from '@/hooks/useAuth';
import { useNewNotificationToasts } from '@/hooks/useNewNotificationToasts';
import { useNotificationTabTitle } from '@/hooks/useNotificationTabTitle';
import { useWorkspaceBrandTheme } from '@/hooks/useWorkspaceBrandTheme';
import { PractitionerMobileHeader } from './PractitionerMobileHeader';
import { PractitionerMobileNav } from './PractitionerMobileNav';
import { PractitionerSidebar } from './PractitionerSidebar';
import { PractitionerTopbar } from './PractitionerTopbar';

export function PractitionerShell() {
  const { isElevatedWorkspaceAccess, activeTenantId } = useAuth();
  useNewNotificationToasts();
  useNotificationTabTitle();
  useWorkspaceBrandTheme();
  return (
    <AssistantProviders>
      <div className="h-screen overflow-hidden flex bg-zoooffwhite font-sans">
        <PractitionerSidebar />
        <div className="flex-1 flex flex-col min-w-0 min-h-0">
          <PractitionerMobileHeader />
          <PractitionerTopbar />
          {isElevatedWorkspaceAccess === true ? <ElevatedWorkspaceBanner /> : null}
          <CalendarReauthorizationBanner />
          <div className="flex-1 flex min-h-0">
            <main className="flex-1 min-w-0 min-h-0 overflow-y-auto pb-14 lg:pb-0">
              <Outlet />
            </main>
            <AssistantPanel key={activeTenantId === null ? '' : activeTenantId} />
          </div>
        </div>
        <PractitionerMobileNav />
      </div>
    </AssistantProviders>
  );
}
